module.exports = __webpack_public_path__ + "img/slide_img.696a2217.png";